'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var at = require('./at.js');
function pullAt(arr, indicesToRemove) {
    var removed = at.at(arr, indicesToRemove);
    var indices = new Set(indicesToRemove.slice().sort(function(x, y) {
        return y - x;
    }));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indices[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var index = _step.value;
            arr.splice(index, 1);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return removed;
}
exports.pullAt = pullAt;
